export const TwitterIcon = ({fill="#151C48"}) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_73_922)">
      <path
        d="M18 0C27.9514 0 36 8.04857 36 18C36 27.9514 27.9514 36 18 36C8.04857 36 0 27.9514 0 18C0 8.04857 8.04857 0 18 0ZM14.7086 27.4886C22.68 27.4886 27.0514 20.88 27.0514 15.1457V14.58C27.9 13.9629 28.6457 13.1914 29.2114 12.3171C28.44 12.6514 27.5914 12.8829 26.7171 13.0114C27.6171 12.4714 28.3114 11.6229 28.62 10.62C27.7714 11.1086 26.8457 11.4686 25.8686 11.6743C25.0714 10.8257 23.94 10.3114 22.7057 10.3114C20.3143 10.3114 18.36 12.2657 18.36 14.6571C18.36 14.9914 18.3857 15.3257 18.4886 15.6343C14.8886 15.4543 11.6743 13.7314 9.54 11.1086C9.18 11.7514 8.94857 12.4971 8.94857 13.2943C8.94857 14.7857 9.72 16.1229 10.8771 16.8943C10.1571 16.8943 9.48857 16.6886 8.92286 16.3543V16.4057C8.92286 18.5143 10.4143 20.2629 12.3943 20.6743C12.0343 20.7771 11.6486 20.8286 11.2629 20.8286C10.98 20.8286 10.7229 20.8029 10.44 20.7514C10.98 22.4743 12.6 23.7343 14.4771 23.76C12.9857 24.9171 11.1086 25.6114 9.07714 25.6114C8.71714 25.6114 8.38286 25.6114 8.04857 25.56C9.95143 26.7943 12.24 27.5143 14.6829 27.5143"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_73_922">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
